
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M16.881 1.166c6.848 0 12.4 5.551 12.4 12.399 0 4.193-2.083 7.9-5.269 10.144a19 19 0 0 1 15.651 8.738L32.4 39.49l-4.983-4.906a2.938 2.938 0 0 0-4.124 4.187l3.262 3.211-21.313 5.305a18.996 18.996 0 0 1 9.73-21.47c-5.942-.919-10.49-6.055-10.49-12.253 0-6.848 5.551-12.4 12.4-12.4"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"m45.602 30.218-13.787 13.37-6.267-6.171m6.584-8.718c-3.132-2.106-6.864-3.258-10.7-3.304-3.837-.046-7.597 1.017-10.784 3.048-3.187 2.03-5.65 4.933-7.061 8.324M32.249 13.62c0 6.426-5.21 11.635-11.635 11.635-6.426 0-11.635-5.21-11.635-11.635 0-6.426 5.209-11.635 11.635-11.635s11.635 5.21 11.635 11.635Z"}})])
          )
        }
      }
    